import React from 'react'
import {connect} from 'react-redux'
import TabContent from '../../components/Dataquest/TabContent'
import { receiveDataquestData } from '../../actions/statusesActions'

const mapStateToProps = (state) => {
  return {
    dataquestData: state.adminStatuses.dataquest
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveDataquestData: (data) => {
      dispatch(receiveDataquestData(data))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TabContent)


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/containers/Dataquest/TabContentContainer.jsx